var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDibetology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.09277,
    y: 1.21094,
    width: 72.8042,
    height: 72.8042,
    rx: 7.5,
    stroke: "#222222",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7734 45.3494C56.7748 47.0272 55.4009 48.3466 53.6509 48.348C51.9009 48.3495 50.5248 47.0323 50.5234 45.3545C50.5221 43.6767 53.6441 39.959 53.6441 39.959C53.6441 39.959 56.7722 43.7914 56.7734 45.3494Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1305 33.4536L55.5879 33.4384C56.8122 33.4374 57.8055 34.4357 57.8065 35.6681C57.8075 36.9006 56.8158 37.9005 55.5916 37.9015H55.5863C55.6757 37.7259 55.7247 37.5352 55.7245 37.3357C55.7239 36.4671 54.7905 35.7636 53.6399 35.7646C52.4893 35.7655 51.5572 36.4705 51.5578 37.3392C51.558 37.5386 51.6073 37.7293 51.6971 37.9047L38.1324 37.916L38.1333 39.0317L45.3093 39.0258C46.4598 39.0249 47.3933 39.9631 47.3943 41.1213L47.3945 41.39C47.3954 42.5482 46.4634 43.488 45.3128 43.4889L38.137 43.4949L38.1378 44.6106L44.1564 44.6057C45.307 44.6047 46.2404 45.543 46.2414 46.7012L46.2417 46.9698C46.2426 48.1281 45.3106 49.0678 44.16 49.0688L35.8267 49.0757L35.8276 50.1914L40.11 50.188C41.2605 50.1869 42.1941 51.1251 42.195 52.2834L42.1952 52.5521C42.1962 53.7103 41.2642 54.6501 40.1137 54.651L32.359 54.6574L28.0889 54.661C21.4981 54.6664 16.1509 49.2922 16.1455 42.6574C16.1415 37.7766 19.0715 33.3784 23.5588 31.5296L36.9782 26.0004C37.9924 25.5825 39.159 25.9079 39.8149 26.7917C40.7319 28.0271 40.2824 29.7992 38.8894 30.441L36.6963 31.4515C35.6784 31.9203 36.0113 33.4546 37.1305 33.4536Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDibetology);
export default __webpack_public_path__ + "static/media/dibetology.0e9a7a2d87e0729f90bd2e7e6d1c6103.svg";
export { ForwardRef as ReactComponent };